<template>
    <div class="header">
        <div class="container flex">
            <div class="w-50">
                <a href="https://artioscollege.org"><img src="/img/artios-main-1.jpg" /></a>
            </div>
            <div class="w-50 flex flex-justify-end">
                <div class="financial-aid-header-tab shake-animation">
                    <a style="text-decoration:none" class="header-text-link" :href="this.$i18n.locale() == 'en' ? 'https://artioscollege.org/sponsorship/' : 'https://artioscollege.org/es/sponsorship/'" target="_blank">{{$t('Financial Assistance')}}</a>
                </div>
            </div>
        </div>
        <nav class="navbar navbar-inverse navbar-static-top" role="navigation">
            <div class="container">
                <!-- Brand and toggle get grouped for better mobile display -->
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <router-link id="navbar-brand-link" class="navbar-brand" to="/" target="_self">my<b>Artios</b></router-link>
                </div>

                <div class="collapse navbar-collapse" id="navbar-collapse">
<!--                    <ul class="nav navbar-nav">
                        @foreach ($top_navigation as $nav)
                        @if(count($nav->allowedChildren()) > 0)
                        <li class="dropdown {{ ($nav->active())?'active':'' }}">
                            <a href="{{ route($nav->route) }}" class="dropdown-toggle" data-toggle="dropdown" target="_self">
                                {{ $nav->label }} <span class="caret"></span>
                            </a>

                            <ul class="dropdown-menu" role="menu">
                                @foreach($nav->allowedChildren() as $child)
                                <li {{ ($child->active())?'class="active"':'' }}><a href="{{ route($child->route) }}" target="_self">{{ $child->label }}</a></li>
                                @endforeach
                            </ul>
                        </li>
                        @else
                        <li {{ ($nav->active())?'class="active"':'' }}><a href="{{ route($nav->route) }}" target="_self">{{{ $nav->label }}}</a></li>
                        @endif
                        @endforeach
                        <li>
                            @include('layouts.partials.choose-locale')
                        </li>
                    </ul>-->
                    <ul class="nav navbar-nav navbar-header">
                        <li v-if="$allowed('admin')" class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Admin <span class="caret"></span></a>
                            <ul class="dropdown-menu navbar-admin">
                                <li><router-link to="/email/compose">Email</router-link></li>
                                <li><router-link to="/admin/forms/log/clpa">Forms</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/canned-reports">Canned Reports</router-link></li>
                                <li><router-link to="/reports">Reports</router-link></li>
                                <li><router-link to="/user">Users</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/coupon-type">Coupon Types</router-link></li>
                                <li><router-link to="/coupon">Coupons</router-link></li>
                                <li><router-link to="/sponsorships">Sponsorships</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/program-type">Program Types</router-link></li>
                                <li><router-link to="/program">Programs</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/year">Academic Years</router-link></li>
                                <li><router-link to="/term-type">Term Types</router-link></li>
                                <li><router-link to="/term">Terms</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/locations">Locations</router-link></li>
                                <li><router-link to="/location-categories">Location Formats</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/credit-type">Credit Types</router-link></li>
                                <li><router-link to="/grade-type">Grade Types</router-link></li>
                                <li><router-link to="/grade">Grades</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/course">Courses</router-link></li>
                                <li><router-link to="/period">Class Periods</router-link></li>
                                <li><router-link to="/class">Classes</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/admin/workshop">{{$t('Workshops')}}</router-link></li>
                                <li><router-link to="/resource">Resources</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/active-student-exception-requests">Active Student Exception Requests</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/page/category">Page Categories</router-link></li>
                                <li><router-link to="/page">Pages</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/settings">Settings</router-link></li>
                                <li><router-link to="/privacy/policy">Privacy Policy</router-link></li>
                            </ul>
                        </li>
                        <li v-if="$allowed('instructor')" class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Instructor <span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li><router-link to="/instructor/course-extensions">Course Extensions</router-link></li>
                            </ul>
                        </li>
                        <li v-if="$allowed('sponsor')" class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Sponsor <span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li><router-link to="/sponsorship/payment">Payment</router-link></li>
                            </ul>
                        </li>
                        <li v-if="$allowed('dean')" class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Dean <span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li><router-link to="/dean/course-extensions">Course Extensions</router-link></li>
                                <router-link tag="li" role="presentation" :to="$url('dean/form/feedback')"><a>Feedback</a></router-link>
                            </ul>
                        </li>
                        <li v-if="$allowed('guest')" class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{$t("Learn")}} <span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li><router-link to="/programs"><i class="fa fa-fw fa-graduation-cap"></i> {{$t("Programs")}}</router-link></li>
                                <li><router-link to="/courses"><i class="fa fa-fw fa-th-large"></i> {{$t("Courses")}}</router-link></li>
                                <li><router-link to="/workshops"><i class="fa fa-fw fa-th"></i> {{$t("Workshops")}}</router-link></li>
                                <li><router-link to="/workshops"><i class="fa fa-fw fa-th-list"></i> {{$t("Audits")}}</router-link></li>
                                <li><router-link to="/resources"><i class="fa fa-fw fa-bullhorn"></i> {{$t("Leadership Tools")}}</router-link></li>
                                <li v-if="$allowed('seminars')"><router-link to="/seminars"><i class="fa fa-fw fa-television"></i> {{$t("Seminars")}}</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li><router-link to="/credit-by-demonstrated-competency">{{$t("Credit by Demonstrated Competency")}}</router-link></li>
                                <li><router-link to="/practicum">{{$t("Practicum")}}</router-link></li>
                                <li><router-link to="/textbooks">{{$t("Textbooks")}}</router-link></li>
                                <li><router-link to="/catalog/current/home">{{$t("Academic Catalog")}}</router-link></li>
                                <li><router-link to="/tutorials/index">{{$t("Tutorials")}}</router-link></li>
                            </ul>
                        </li>
                        <li v-if="$allowed('user')" class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{$t("Forms")}} <span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li v-if="$allowed('user')" v-for="form in forms"><router-link :to="form.to">{{form.title}}</router-link></li>
                            </ul>
                        </li>
                        <li v-if="$allowed('guest')" class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{$t("Alumni")}} <span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li v-if="$allowed('guest')"><router-link to="/forms/commencement">{{ $t('Commencement Registration') }}</router-link></li>
                                <li v-if="$allowed('guest')"><router-link to="/forms/transcript-request">{{ $t('Transcript Request') }}</router-link></li>
                            </ul>
                        </li>
                        <li><router-link to="/give">{{$t('Give')}}</router-link></li>
                    </ul>
                    <ul class="nav navbar-nav navbar-right">
                        <li class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{ ($i18n.locale() == 'en')?'English':'Español' }}<span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li><a @click="setLocale('en')" class="clickable">English</a></li>
                                <li><a @click="setLocale('es')" class="clickable">Español</a></li>
                            </ul>
                        </li>
                        <li v-if="$root.app.user.username == 'guest'"><router-link to="/login">{{ $t("Login") }}</router-link></li>
                        <li v-else class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                <avatar :user="$root.app.user.id" size="icon" class="img-circle" id="menu-user-avatar" /> {{ $root.app.user.name }}
                                <span class="caret"></span></a>
                            <ul class="dropdown-menu">
                                <li><router-link to="/profile">{{ $t("Profile") }}</router-link></li>
                                <li v-if="$allowed('user')"><router-link to="/checkout">{{ $t('Payment') }} / {{ $t('Checkout') }}</router-link></li>
                                <li role="separator" class="divider"></li>
                                <li v-if="$root.app.user.original === null"><a href="/api/logout">{{ $t("Logout") }}</a></li>
                                <li v-else=""><a href="/api/logout">Switch back to {{ $root.app.user.original }}</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        name: 'page-header',
        computed: {
            applications() {
                let applications = [];

                applications.push({to:"/forms/christian-leadership-app", title: this.$t("ACL/BACL Program Application")});
                applications.push({to:"/forms/leadership-certificate-app", title: this.$t("Certificate of Leadership Studies Application")});

                return this.$sort(applications, o => o.title);
            },
            forms() {
                let forms = [];    
            
                forms.push({to:"/forms/active-student-exception-request", title: this.$t('Active Student Exception Request') });
                forms.push({to:"/forms/information-release-authorization", title: this.$t('Sponsorship Profile Release Authorization') });
                forms.push({to:"/forms/authorization", title: this.$t('Authorization') });
                forms.push({to:"/forms/authorization-retraction", title: this.$t('Retraction of Authorization') });
                forms.push({to:"/forms/program-transfer", title: this.$t("Program Transfer") });
                forms.push({to:"/forms/q-drop", title: this.$t('Q-Drop') });
                forms.push({to:"/forms/withdraw", title: this.$t('Course Withdrawal') });
                forms.push({to:"/forms/course-extension", title: this.$t('Course Extension Request') });
                forms.push({to:"/forms/program-completion", title: this.$t('Program Completion') });

                forms.push({to:"/forms/competency-exam-registration", title: this.$t('Competency Exam Registration') });
                forms.push({to:"/forms/leadership-experience-portfolio-registration", title: this.$t('Leadership Experience Portfolio Registration') });
                forms.push({to:"/forms/sat-campus-course-reg", title: this.$t('Satellite Campus Course Registration') });

                return this.$sort(forms, o => o.title);
            }    
        },
        methods: {
            setLocale(locale)
            {
                this.$http.put('/api/locale', {locale: locale}).then(response => {
                    if(response.data.success)
                    {
                        const route = Object.assign({}, this.$route);
                        route.params.locale = locale;
                        this.$router.push(route);
                    }
                });
            }
        }
    }
</script>
